import { render, staticRenderFns } from "./fieldForm.vue?vue&type=template&id=8fd8fc38&scoped=true&"
import script from "./fieldForm.vue?vue&type=script&lang=js&"
export * from "./fieldForm.vue?vue&type=script&lang=js&"
import style0 from "./fieldForm.vue?vue&type=style&index=0&id=8fd8fc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd8fc38",
  null
  
)

export default component.exports